/* eslint-disable */
import isMobile from 'ismobilejs'

export default function() {
  const footer = document.querySelector('.footer')

  if (isMobile().any || window.innerHeight < footer.clientHeight) {
    footer.classList.add('no-sticky')
    return false
  }

  const siteContent = document.querySelector('.site-content')
  const makeSpaceForFooter = function() {
    siteContent.style.marginBottom = `${footer.clientHeight}px`
  }
  if (footer && siteContent) {
    makeSpaceForFooter()
    window.addEventListener('resize', makeSpaceForFooter)
  }
}
